import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Divider } from '@mui/material';
import { TCandidate } from './types';
import { AccessTimeFilled, Cancel, CheckCircle } from '@mui/icons-material';

interface CandidateDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  candidate: TCandidate | null;
  conditions: Array<{ id?: number; content: string; weight: number; short_label?: string }>;
}

const CandidateDetailsDialog: React.FC<CandidateDetailsDialogProps> = ({ open, onClose, candidate, conditions }) => {
  if (!candidate) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Candidate Details</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Name: {candidate.firstname} {candidate.lastname}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Email: {candidate.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          Suitability Analysis
        </Typography>
        <Typography variant="body1">{candidate.suitability_comment}</Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="h6" gutterBottom>
          Matching:
          <span style={{ color: candidate.matching_percent_color }}>
            {candidate.matching_percent}%
          </span>
        </Typography>
        {conditions.map((condition, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="subtitle1">
              <span>
                {candidate.assessed ? (
                  candidate.matched_condition_ids.includes(condition.id) ? (
                    <CheckCircle color="success" />
                  ) : (
                    <Cancel color="error" />
                  )
                ) : (
                  <AccessTimeFilled color="disabled" />
                )}
              </span>
              <span>{condition.content}</span>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Weight: {condition.weight}
            </Typography>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CandidateDetailsDialog; 
